/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import CampaignPromoBarModuleRenderer, {
  useShouldShowCampaignPromoBarModule,
} from 'bundles/campaigns/module-renderers/CampaignPromoBarModuleRenderer';
import PageBannerModule from 'bundles/unified-description-page-common/components/modules/page-banner/PageBannerModule';
import Markdown from 'bundles/unified-description-page-common/components/shared/Markdown';
import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';
import RegionalPromotionBannerRenderer from 'bundles/unified-description-page-common/module-renderers/RegionalPromotionBannerRenderer';
import type { SelfServeConfigPageBannerModuleFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationMarketingPageQuery';

type Props = {
  config?: SelfServeConfigPageBannerModuleFragment;
};

const styles = {
  container: css`
    overflow: hidden;
  `,
};

const PageBannerModuleRenderer = ({ config }: Props) => {
  const { marketingSource } = usePageInfo();
  if (useShouldShowCampaignPromoBarModule()) {
    return (
      <div css={styles.container}>
        <CampaignPromoBarModuleRenderer />
      </div>
    );
  }

  // This is a temporary solution to show the regional promotion banner for all marketing sources except GOOGLE
  if (marketingSource !== 'GOOGLE') {
    return <RegionalPromotionBannerRenderer variant="blue" />;
  }

  if (config?.message == null) {
    return null;
  }

  return <PageBannerModule message={<Markdown source={config.message} />} />;
};

export default PageBannerModuleRenderer;
